import { toast } from "sonner";
import api from "@/lib/api";

const KEY = "cdm_ref";
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // a link stays valid for 90 days after the click
const CODE_RE = /^[A-Za-z0-9]{4,32}$/;

/** Remember a ?ref=CODE seen on any page, until the visitor signs up. */
export function captureReferralFromSearch(search) {
  try {
    const ref = new URLSearchParams(search || "").get("ref");
    if (ref && CODE_RE.test(ref)) {
      localStorage.setItem(KEY, JSON.stringify({ code: ref.toUpperCase(), at: Date.now() }));
    }
  } catch {
    /* storage blocked -- referral just won't be captured */
  }
}

export function getPendingReferral() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, at } = JSON.parse(raw);
    if (!code || !at || Date.now() - at > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function clearPendingReferral() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Call once right after a session is created (OAuthCallback). Never throws and
 * never blocks login: the server decides whether this merchant is eligible
 * (new, never paid, not self, etc.).
 */
export async function applyPendingReferral() {
  const code = getPendingReferral();
  if (!code) return;
  try {
    const { data } = await api.post("/referral/apply", { code });
    clearPendingReferral(); // the server answered -> don't retry forever
    if (data?.ok) {
      toast.success(
        data.referrer_username
          ? `Invite from @${data.referrer_username} applied.`
          : "Invite applied."
      );
    }
  } catch (e) {
    // Any HTTP answer (401/403/500...) means "don't keep retrying".
    // No response at all = network blip: keep the code for the next login.
    if (e?.response) clearPendingReferral();
  }
}
